import React from "react";
import { Typography, Popover, Badge } from "antd";
import { CURRENT_STROKE, VIEW_MODE_JD, TEXT } from "../../EmployeeSkillsBridgerV2.constants";
import { TYPE_SECONDARY } from "constants/ui.constants";
import {
  TitleWrapperStyled,
  LegendRowStyled,
  LegendCaretIconStyled,
  PopoverTitleWrapperStyled,
  PopoverTitleIconStyled,
  PopoverTitleTextStyled,
  PopoverContentStyled,
  PopoverTriggerIconStyled,
  POPOVER_STYLES_CONFIG,
} from "./InferredProficiencyTitle.styles";

const { Text } = Typography;

// Module-level: JSX is stable — never re-created on render.
const POPOVER_TITLE = (
  <PopoverTitleWrapperStyled>
    <PopoverTitleIconStyled />
    <PopoverTitleTextStyled>{TEXT.POPOVER_QUESTION}</PopoverTitleTextStyled>
  </PopoverTitleWrapperStyled>
);

const POPOVER_CONTENT = (
  <PopoverContentStyled>{TEXT.POPOVER_BODY}</PopoverContentStyled>
);

const InferredProficiencyTitle = React.memo(({ viewMode }) => (
  <TitleWrapperStyled>
    <div>
      <div style={{ textTransform: "uppercase" }}>
        {TEXT.INFERRED_PROFICIENCY_TITLE}{" "}
        <Text type={TYPE_SECONDARY}>{TEXT.PROFICIENCY_SCALE_RANGE}</Text>
      </div>
      <LegendRowStyled>
        <Badge color={CURRENT_STROKE} />
        <Text type={TYPE_SECONDARY}>{TEXT.CURRENT_PROFICIENCY_LABEL}</Text>
        {viewMode === VIEW_MODE_JD && (
          <>
            <LegendCaretIconStyled />
            <Text type={TYPE_SECONDARY}>{TEXT.REQUIRED_PROFICIENCY_LABEL}</Text>
          </>
        )}
      </LegendRowStyled>
    </div>
    <Popover
      trigger="hover"
      placement="bottom"
      styles={POPOVER_STYLES_CONFIG}
      title={POPOVER_TITLE}
      content={POPOVER_CONTENT}
    >
      <PopoverTriggerIconStyled />
    </Popover>
  </TitleWrapperStyled>
));

export default InferredProficiencyTitle;
